/* import __COLOCATED_TEMPLATE__ from './new-badge.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './new-badge.module.scss';

@classic
@classNames(styles.component)
export default class SiteDocumentsNewBadge extends Component {}
